/*
THIS COMPONENT IS INCLUDED IN FORM-EDIT BONUS RULES PAGE
 -----------------------------------------*/
let BonusRulesHelper = function () {

    const PROMO_CODE_TYPE = 'promo_code';

    const INPUTS_TO_HIDE = [
        'bonus_rule_condition',
        // 'bonus_rule_quantity_limit'
    ];

    const BONUS_RULE_TYPE_ID = 'bonus_rule_type';

    let init = () => {
        listenOnLoad();
        listenBonusRuleTypeChange();
    };

    let listenOnLoad = () => {
        let bonusRuleType = document.getElementById(BONUS_RULE_TYPE_ID).value;
        if (isPromoCodeTypeSelected(bonusRuleType)) {
            hideUnnecessaryInputs();
        }
    };

    let listenBonusRuleTypeChange = () => {
        document.getElementById(BONUS_RULE_TYPE_ID).addEventListener('change', event => {
            let bonusRuleType = event.target.value;
            if (isPromoCodeTypeSelected(bonusRuleType)) {
                hideUnnecessaryInputs();
                return;
            }
            showAllInputs();
        });
    };

    let isPromoCodeTypeSelected = (selectedType) => {
        return selectedType === PROMO_CODE_TYPE;
    };

    let hideUnnecessaryInputs = () => {
        INPUTS_TO_HIDE.forEach( item => {
            document.getElementById(item).style.display = 'none';
        });
    };

    let showAllInputs = () => {
        INPUTS_TO_HIDE.forEach( item => {
            document.getElementById(item).style.display = 'block';
        });
    };

    return {
        init: init
    };

}();

export default BonusRulesHelper;
